import React from 'react'

function CampaignBrandMessage({ content }) {
  return (
    <div
      className="Grid u-bgColorWhite u-paddingVert3gu"
      data-collapsible="true"
      data-brand-message="generic"
    >
      <div className="u-flex u-flexAlignItemsCenter u-sizeConstrained">
        <p className="u-textSizeMsrp2 u-textSecondary u-textColorBrand">
          {content}
        </p>
      </div>
    </div>
  )
}

export default CampaignBrandMessage
